'use client';

import NotFoundKG from '@/components/kg/errors/NotFoundKG';

export default NotFoundKG;
